var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Button, theme } from '@robinpowered/ui-kit';
import { useTranslation } from 'react-i18next';
import { useEventComposerGlobalContext } from '../../../composers/EventComposerGlobalContext';
var actionButtonStyle = {
    width: '100%',
    alignSelf: 'flex-start',
};
/**
 * Remove/Change act on the form only, so neither needs a confirmation.
 * In EDIT mode, removed spaces are declined on the server when the event
 * is saved (see declineRemovedSpaces in EditEventContext).
 */
export var useSpaceActions = function (_a) {
    var spaceId = _a.spaceId, spaceInviteeId = _a.spaceInviteeId, onChangeSpace = _a.onChangeSpace, userCanRemoveSpace = _a.userCanRemoveSpace;
    var tSpaceBooking = useTranslation('spaceBooking').t;
    var token = theme.useToken().token;
    var _b = useEventComposerGlobalContext(), pendingSpaceSwap = _b.pendingSpaceSwap, removeSpace = _b.removeSpace;
    var isSpaceChangePending = (pendingSpaceSwap === null || pendingSpaceSwap === void 0 ? void 0 : pendingSpaceSwap.spaceId) === spaceId;
    return useMemo(function () {
        if (!userCanRemoveSpace)
            return [];
        return [
            _jsx(Button, { variant: "outlined", type: "text", size: "small", onClick: function () { return onChangeSpace(spaceId, spaceInviteeId); }, style: actionButtonStyle, disabled: !!isSpaceChangePending, loading: isSpaceChangePending, children: isSpaceChangePending
                    ? tSpaceBooking('change_space.changing_space')
                    : tSpaceBooking('change_space.action') }, "change"),
            _jsx(Button, { variant: "outlined", type: "text", size: "small", onClick: function () { return removeSpace(spaceId); }, style: __assign(__assign({}, actionButtonStyle), { color: token.colorError }), children: tSpaceBooking('remove_space.action') }, "remove"),
        ];
    }, [
        isSpaceChangePending,
        onChangeSpace,
        removeSpace,
        spaceId,
        spaceInviteeId,
        tSpaceBooking,
        token.colorError,
        userCanRemoveSpace,
    ]);
};
